module.exports = __webpack_public_path__ + "img/coverfx5.3a1cad80.jpg";